import { coordinateToGoogleLatLng } from '@/components/map/utils/neotaste-map-helpers'
import { ApiResponseBody, userApiClient } from '@/setup/api'
import { ArrayItem } from '@/utils/typings/array-item'

export type IGetCityRestaurantsMapQueryData = ApiResponseBody<
    'get',
    '/web/restaurants/cities/{citySlug}/restaurants/map/all'
>['data']

export type IMapRestaurant = ArrayItem<IGetCityRestaurantsMapQueryData>

export const getCityRestaurantsMapQueryOptions = (citySlug: string, locale: string) =>
    userApiClient.queryOptions('get', '/web/restaurants/cities/{citySlug}/restaurants/map/all', {
        params: { path: { citySlug } },
        headers: { 'accept-language': locale },
    })

/**
 * `google.maps.LatLng` instances are not serialisable and the `google` global only
 * exists in the browser, so they must not end up in the query cache. Callers map the
 * cached response through this at read time instead.
 */
export const toGoogleMapsRestaurants = (restaurants: IGetCityRestaurantsMapQueryData) =>
    restaurants.reduce<(IMapRestaurant & { latLng?: google.maps.LatLng })[]>(
        (acc, cityRestaurant) => {
            if (!cityRestaurant.latitude || !cityRestaurant.longitude) {
                // biome-ignore lint/suspicious/noConsole: data integrity warning
                console.error('City restaurant is missing latitude or longitude', cityRestaurant)
                return acc
            }

            const latLng = new google.maps.LatLng(
                coordinateToGoogleLatLng({
                    latitude: cityRestaurant.latitude,
                    longitude: cityRestaurant.longitude,
                })
            )

            return acc.concat({ ...cityRestaurant, latLng })
        },
        []
    )
